const partTypeFilterHelpers = require('public/templates/modules/part_type_filter/utils');

/* global rp$, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	// require('select2');

	/********************************************
	 * Load Javascript for the OEM Sidebar Page
	 * -----------------------------------------
	 * @section oem_sidebar_js
	 ********************************************/
	(function OemSidebarModule() {
		// Show accessories if there are no auto-parts categories
		$onReady({
			rp$, window,
			label: 'oem_sidebar',
			fn: function() {
				// Default State - Auto Parts Active
				var hasAutoParts = !!rp$('.oem-top-level-categories-module').find('.p_cats_list').length;
				var hasAccessories = !!rp$('.oem-top-level-categories-module').find('.a_cats_list').length;
				var hasTires = !!rp$('.oem-top-level-categories-module').find('.t_cats_list').length;
				var $categorySearches = rp$('#parts-category-search');
				var currentUrl = rp$('.oem-sidebar-module').data('current-category');

				// Initial State | read $currentUrl
				if (rp$('.page-content').is('#layout_search') || currentUrl === 'oem-accessory-cats') {
					rp$('#rp_webstore').removeClass('show-tires').addClass('show-accessories');
					rp$('.cat-accessories').addClass('active-cat');
					if ((currentUrl === 'oem-accessory-cats') && !hasAccessories) {
						rp$('.oem-top-level-categories-module').find('.no-parts-image-container.no-parts').addClass('hide');
						rp$('.oem-top-level-categories-module').find('.no-parts-image-container.no-accessories').addClass('show');
					}
				} else if (currentUrl === 'oem-parts-cats' || currentUrl === 'oem-assemblies') {
					rp$('#rp_webstore').removeClass('show-accessories').removeClass('show-all-parts').removeClass('show-tires').addClass('show-parts');
					rp$('.cat-autoparts').addClass('active-cat');
				} else if (currentUrl === 'oem-tires') {
					rp$('#rp_webstore').removeClass('show-accessories').removeClass('show-parts').removeClass('show-all-parts').addClass('show-tires');
					rp$('.cat-tires').addClass('active-cat');
				} else {
					rp$('#rp_webstore').removeClass('show-accessories').removeClass('show-parts').removeClass('show-tires').addClass('show-all-parts');
					rp$('.cat-allparts').addClass('active-cat');
				}

				// rp$('.category-search #parts-category-search').select2({
				// 	maximumSelectionLength: 1,
				// 	dropdownParent: rp$('#rp_webstore'),
				// 	placeholder: select2Placeholder,
				// });

				// rp$('#parts-category-search').on('select2:select', function (e) {
				// 	rp$(this).parents().find('.category-loading').show();
				// 	rp$(this).parent().hide();
				// });

				rp$($categorySearches).on('change', function() {
					var url = rp$(this).val();
					if (url) {
						if (Array.isArray(url)) {
							url = url[0];
						}
						rp_app.location.redirect(url);
					}
					return false;
				});

				rp$('.p_cats_list').on('shown.bs.collapse', function (e) {
					var openCategoryTop = rp$('.collapse.in').parent().offset().top;
					var top = rp$(window).scrollTop();
					if(openCategoryTop) {
						if(openCategoryTop < top) {
							rp$('html,body').animate({
								scrollTop: rp$('.collapse.in').parent().offset().top -20
							}, 300);
						}
					}
				});

				if (!hasAutoParts && !hasTires && rp$('.oem-top-level-categories-module')[0] && currentUrl !== 'oem-tires') {
					rp$('#rp_webstore').removeClass('show-parts').removeClass('show-tires').addClass('show-accessories');
					rp$('.cat-accessories').addClass('active-cat');
					rp$('.cat-allparts').removeClass('active-cat');
					rp$('.cat-autoparts').removeClass('active-cat');
					rp$('.cat-tires').removeClass('active-cat');
				}
				// $('.category-search').find('.select2-search__field').attr('placeholder', $activeSearchCat);
				// if(rp$('.select2-search__field')[0]){
				// 	rp$('.category-loading').hide();
				// }
				rp$('.category-loading').hide();

				rp$('.part-type-filter-form .select-filter').on('change', function(e) {
					e.preventDefault();
					var optionSelected = rp$('option:selected', this);
					const url = optionSelected.attr('data-url-redirect');
					if (url) {
						partTypeFilterHelpers.showSpinner();
						rp_app.location.redirect(url);
					}
				});

				rp$('.part-type-filter-form .radio-group-filter').on('change', function(e) {
					e.preventDefault();
					var optionSelected = rp$('input:checked', this);
					const url = optionSelected.attr('data-url-redirect');
					if (url) {
						partTypeFilterHelpers.showSpinner();
						rp_app.location.redirect(url);
					}
				});
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
